import { Directive, HostBinding, Input } from '@angular/core';
import { FormGroupDirective, UntypedFormControl } from '@angular/forms';

@Directive({
  selector: '[comFormMessageName]',
})
export class FormMessageNameDirective {
  @Input('comFormMessageName') fieldName: string;
  @Input() validation: string = null;

  private cachedFieldObject: UntypedFormControl;

  constructor(private parentForm: FormGroupDirective) {}

  @HostBinding('class.form__error-message') get defaultClass() { return true; }

  @HostBinding('style.display') get styleDisplay() {
    if (this.validation === null)  {
      return this.fieldObject?.invalid
              && this.fieldObject?.touched ? 'inline-block' : 'none';
    } else {
      return this.fieldObject?.invalid
              && this.fieldObject?.touched
              && this.fieldObject?.hasError(this.validation) ? 'inline-block' : 'none';
    }
  }

  private get fieldObject(): UntypedFormControl {
    if (this.cachedFieldObject) {
      return this.cachedFieldObject;
    }
    this.cachedFieldObject = this.parentForm.directives.find((directive) => directive.name === this.fieldName)?.control;
    return this.cachedFieldObject;
  }
}
